import { render } from "./FoundationTemplateContentEditor.vue?vue&type=template&id=4704c346&scoped=true"
import script from "./FoundationTemplateContentEditor.vue?vue&type=script&lang=js"
export * from "./FoundationTemplateContentEditor.vue?vue&type=script&lang=js"

import "./FoundationTemplateContentEditor.vue?vue&type=style&index=0&id=4704c346&scoped=true&lang=css"

import exportComponent from "/Users/brianschroeter/Documents/Codex/2026-10-09/task/giving-dashboard-donor-fix/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4704c346"]])

export default __exports__